import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const retentionData = [{
  category: "Personal Contact Information",
  period: "Active + 1 Year",
  purpose: "Maintained for essential communication and service coordination in strict accordance with GDPR data minimization and storage limitation requirements."
}];
export default function DataRetention() {
  return <section id="data-retention" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 text-foreground">
            Personal Contact Information Retention
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg">
            We maintain personal contact data only for as long as necessary to fulfill the purposes for which it was collected, ensuring full compliance with GDPR standards for data protection and privacy lifecycle management.
          </p>
        </div>

        <div className="border border-secondary p-1 bg-transparent">
          <Table className="border-collapse w-full">
            <TableHeader>
              <TableRow className="border-secondary hover:bg-transparent hover:shadow-none">
                <TableHead className="font-serif font-semibold uppercase text-[14px] text-foreground border-b border-secondary h-14 align-bottom pb-4">
                  Data Category
                </TableHead>
                <TableHead className="font-serif font-semibold uppercase text-[14px] text-foreground border-b border-secondary h-14 align-bottom pb-4">
                  Retention Period
                </TableHead>
                <TableHead className="font-serif font-semibold uppercase text-[14px] text-foreground border-b border-secondary h-14 align-bottom pb-4">
                  Primary Purpose
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {retentionData.map((item, i) => <TableRow key={i} data-index={i} className="border-secondary bg-transparent hover:bg-chart-1/5 hover:shadow-[0_0_15px_hsla(220,45%,15%,0.15)] transition-all duration-300 relative z-0 hover:z-10 group">
                  <TableCell className="font-medium py-5 text-foreground group-hover:text-chart-1 transition-colors">
                    {item.category}
                  </TableCell>
                  <TableCell className="py-5 font-mono text-sm text-foreground">
                    {item.period}
                  </TableCell>
                  <TableCell className="py-5 text-muted-foreground">
                    {item.purpose}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}